import { getSensorsHealthStatus, getSensorsHealthStatusLegacy } from '@Actions';
import { getValue } from '@Selectors';
import { STATUS_ENUM } from '@Types';
import { SensorsUptimeDataRequest } from '@Types/edgeAnalytics.types';
import {
	filterByAllowedHealthStatusDataSource,
	mapUptimeDataRequest,
} from '@Utils/sensorsAnalytics';
import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

interface SensorsHealthStatusProps {
	shoulFetchHealthStatus: boolean;
	isSensorHealthV3ApiEnabled: boolean;
	unloadLagMinutes: string;
}

export const useSensorsHealthStatus = ({
	unloadLagMinutes,
	shoulFetchHealthStatus = false,
	isSensorHealthV3ApiEnabled = false,
}: SensorsHealthStatusProps) => {
	const dispatch = useDispatch();
	const { sensorsHealthStatus } = useSelector(getValue).sensors;
	const {
		configurations: { list },
		systemConnections: {
			list: systemConnections,
			initialized: systemConnectionsInitialized,
		},
	} = useSelector(getValue);

	useEffect(() => {
		if (list.length > 0 && shoulFetchHealthStatus) {
			const filteredSensors = filterByAllowedHealthStatusDataSource(list);

			if (
				filteredSensors.length > 0 &&
				isSensorHealthV3ApiEnabled &&
				systemConnectionsInitialized
			) {
				const sensors = mapUptimeDataRequest(
					systemConnections,
					filteredSensors,
					Number.parseInt(unloadLagMinutes || '0'),
				);
				fetchSensorsHealthStatus(sensors);
			} else if (
				filteredSensors.length > 0 &&
				!isSensorHealthV3ApiEnabled
			) {
				const sensorIds = filteredSensors.map(
					sensor => sensor.sensorId,
				);
				fetchSensorsHealthStatusLegacy(sensorIds);
			}
		}
	}, [JSON.stringify(list), systemConnectionsInitialized, systemConnections]);

	const fetchSensorsHealthStatus = useCallback(
		(sensors: SensorsUptimeDataRequest[]) => {
			dispatch(getSensorsHealthStatus(sensors));
		},
		[],
	);
	/**
	 * @ deprecated
	 */
	const fetchSensorsHealthStatusLegacy = useCallback(
		(sensorsIds: string[]) => {
			dispatch(getSensorsHealthStatusLegacy(sensorsIds));
		},
		[],
	);

	return {
		isSensorsHealthStatusLoading:
			sensorsHealthStatus.status == STATUS_ENUM.PENDING,
		sensorsHealthStatus: sensorsHealthStatus.sensorsMap,
	};
};
